import { render, staticRenderFns } from "./RemesasTabContent.vue?vue&type=template&id=3ccc6018&scoped=true"
import script from "./RemesasTabContent.vue?vue&type=script&lang=js"
export * from "./RemesasTabContent.vue?vue&type=script&lang=js"
import style0 from "./RemesasTabContent.vue?vue&type=style&index=0&id=3ccc6018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccc6018",
  null
  
)

export default component.exports